module.exports = __webpack_public_path__ + "static/media/weixin.b28a903b.svg";